import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const CRM_SIDENAV_LINKS = new InjectionToken<void>("CRM_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("crm", [
      {
        id: "Customers",
        label: "CRM.ITEMS.CUSTOMERS",
        icon: "user",
        routerLink: "/crm/customers",
        permissions: COMMON_GUARD_OPTIONS.CUSTOMER.VIEW.permissions,
      },
      {
        id: "Companies",
        label: "CRM.ITEMS.COMPANIES",
        icon: "company",
        routerLink: "/crm/companies",
        permissions: COMMON_GUARD_OPTIONS.COMPANY.VIEW.permissions,
      },
      {
        id: "duplicationClusters",
        label: "CRM.ITEMS.DUPLICATION_CLUSTERS",
        routerLink: "/crm/duplications",
        icon: "users",
        permissions: COMMON_GUARD_OPTIONS.CRM_DUPLICATION_CLUSTERS.VIEW.permissions,
      },
      {
        id: "BlacklistRule",
        label: "CRM.ITEMS.BLACKLIST_RULES",
        icon: "block",
        routerLink: "/crm/blacklist-rules",
        permissions: COMMON_GUARD_OPTIONS.BLACKLIST_RULE.VIEW.permissions,
      },
      {
        id: "Configurations",
        label: "CRM.ITEMS.CONFIGURATIONS",
        expanded: true,
        icon: "configuration",
        items: [
          {
            id: "DataProcessing",
            label: "CRM.ITEMS.DATA_PROCESSING",
            routerLink: "/crm/data-processing",
            permissions: COMMON_GUARD_OPTIONS.DATA_PROCESSING.VIEW.permissions,
          },
          {
            id: "LicenseCategory",
            label: "CRM.ITEMS.LICENSE_CATEGORIES",
            routerLink: "/crm/license-categories",
            permissions: COMMON_GUARD_OPTIONS.LICENSE_CATEGORY.VIEW.permissions,
          },
          {
            id: "CrmSettings",
            label: "CRM.ITEMS.CRM_SETTINGS",
            routerLink: "/crm/crm-settings",
            permissions: [
              COMMON_GUARD_OPTIONS.CRM_DUPLICATION_SETTINGS.VIEW.permissions,
              [COMMON_GUARD_OPTIONS.CRM_OTP_SETTINGS.VIEW.permissions],
              [COMMON_GUARD_OPTIONS.CRM_OPEN_API_SETTINGS.VIEW.permissions],
              [COMMON_GUARD_OPTIONS.CRM_EMAIL_VALIDITY_SETTINGS.VIEW.permissions],
              [COMMON_GUARD_OPTIONS.CRM_DOCUMENTS_SETTINGS.VIEW.permissions],
              [COMMON_GUARD_OPTIONS.CRM_DATA_CONVALIDATION_SETTINGS.VIEW.permissions],
              COMMON_GUARD_OPTIONS.CUSTOMER_DUPLICATION_RULE.VIEW.permissions,
            ],
          },
        ],
      },
    ]);
  },
});
